import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListResponse } from '@core/api/api.model';
import { IFeature, IFeatureDetail, IPurchaseInfo } from './feature.model';

const MigratedTileImages = ['custom_athlete_categories', 'cycling', 'running', 'swimming_freestyle'];

@Injectable({ providedIn: 'root' })
export class FeatureApi {
  private readonly http = inject(HttpClient);

  getCatalog(): Observable<ApiListResponse<IFeature>> {
    return this.http.get<ApiListResponse<IFeature>>(`${environment.api}features/catalog/`).pipe(
      map((response) => {
        // TODO: Quick hack to show new feature images as they become available
        // Remove when the new images are the defaults
        response.results = response.results.map((backendFeature) => {
          if (MigratedTileImages.includes(backendFeature.slug)) {
            return {
              ...backendFeature,
              image: this.generateS3TileImageFromSlug(backendFeature.slug, backendFeature.image),
            };
          } else {
            return backendFeature;
          }
        });
        return response;
      }),
    );
  }

  getById(id: number): Observable<IFeatureDetail> {
    return this.http.get<IFeatureDetail>(`${environment.api}features/${id}/`).pipe(
      map((backendFeature) => {
        // TODO: As above
        if (MigratedTileImages.includes(backendFeature.slug)) {
          return {
            ...backendFeature,
            image: this.generateS3TileImageFromSlug(backendFeature.slug, backendFeature.image),
          };
        } else {
          return backendFeature;
        }
      }),
    );
  }

  getBySlug(slug: string): Observable<IFeatureDetail> {
    return this.http
      .get<IFeatureDetail>(`${environment.api}features/`, {
        params: { feature_slug: slug },
      })
      .pipe(
        map((backendFeature) => {
          // TODO: As above
          if (MigratedTileImages.includes(backendFeature.slug)) {
            return {
              ...backendFeature,
              image: this.generateS3TileImageFromSlug(backendFeature.slug, backendFeature.image),
            };
          } else {
            return backendFeature;
          }
        }),
      );
  }

  getPurchaseInfo(id: number): Observable<IPurchaseInfo> {
    return this.http.get<IPurchaseInfo>(`${environment.api}features/${id}/purchase-info/`);
  }

  updateSetDependencies(id: number, selectedIds: number[]): Observable<IPurchaseInfo> {
    return this.http.post<IPurchaseInfo>(`${environment.api}features/${id}/purchase-info/`, {
      selected_set_dependencies: selectedIds,
    });
  }

  joinWaitlist(id: number, email: string): Observable<void> {
    return this.http.post<void>(`${environment.api}features/${id}/waitlist/`, { email });
  }

  purchase(featureId: number, additionalDependencies: number[]): Observable<unknown> {
    return this.http.post(`${environment.api}features/purchases/`, {
      feature_id: String(featureId),
      additional_dependencies: additionalDependencies,
    });
  }

  private generateS3TileImageFromSlug(slug: string, fallback: string): string {
    try {
      return `https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/tiles/${slug}.png`;
    } catch (e) {
      return fallback;
    }
  }
}
